"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var GoogleIcon = function GoogleIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.022 5.414a9.297 9.297 0 0 1 2.515-3.185A9.402 9.402 0 0 1 8.505.093c2.187-.26 4.242.155 6.142 1.292.472.283.913.604 1.335.952.104.085.093.136.004.22-.863.86-1.726 1.719-2.582 2.586-.1.1-.154.093-.263.011-2.507-1.93-6.164-1.408-8.033 1.146a5.64 5.64 0 0 0-.782 1.459c-.015.046-.046.089-.07.135-.499-.38-1.002-.758-1.497-1.141-.58-.445-1.16-.89-1.737-1.34z",
    fill: "#E94335"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.257 11.524c.166.367.305.75.514 1.095.879 1.44 2.132 2.364 3.785 2.693 1.49.298 2.921.097 4.256-.65.047-.023.093-.046.136-.07.023.024.042.05.066.07.998.774 2 1.548 2.999 2.322-.48.476-1.026.859-1.606 1.192-1.684.96-3.506 1.346-5.426 1.2-2.391-.186-4.454-1.13-6.156-2.833a8.851 8.851 0 0 1-1.807-2.554c.414-.318.828-.631 1.242-.948.665-.507 1.331-1.01 1.997-1.517z",
    fill: "#34A853"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.016 16.984l-2.998-2.322a.56.56 0 0 1-.066-.07c.344-.267.696-.526.979-.866a4.5 4.5 0 0 0 .948-1.92c.02-.089.004-.12-.085-.116-.047.004-.09 0-.136 0-1.579 0-3.161-.004-4.74.004-.174 0-.213-.046-.209-.213.008-1.122.008-2.244 0-3.366 0-.144.039-.182.182-.182 2.894.004 5.789.004 8.687 0 .124 0 .174.03.205.162.236 1.064.22 2.132.078 3.208-.116.86-.325 1.691-.647 2.496a8.878 8.878 0 0 1-2.097 3.115c-.035.027-.07.047-.1.07z",
    fill: "#4285F3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.257 11.524c-.666.507-1.332 1.01-1.997 1.517-.414.313-.828.63-1.242.948-.321-.596-.53-1.227-.7-1.877A9.756 9.756 0 0 1 .12 8.297c.14-1.007.43-1.974.898-2.88.58.446 1.157.894 1.737 1.34.5.383.999.762 1.498 1.141-.085.414-.205.82-.244 1.246-.07.774.004 1.529.224 2.271.016.031.02.07.024.109z",
    fill: "#FABB06"
  })));
};

GoogleIcon.defaultProps = {
  width: "19",
  height: "20",
  viewBox: "0 0 19 20",
  xmlns: "http://www.w3.org/2000/svg"
};

var MicrosoftIcon = function MicrosoftIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.907 8.945H18.8V.625a.594.594 0 0 0-.593-.595H9.907v8.915z",
    fill: "#5ACF5F"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.907 8.945V.03H.61a.594.594 0 0 0-.593.594v8.321h8.891z",
    fill: "#F84437"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.907 9.945H.016v8.322c0 .328.265.594.593.594h8.298V9.945z",
    fill: "#2299F8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.907 9.945v8.916h8.299a.594.594 0 0 0 .593-.594V9.945H9.907z",
    fill: "#FFC107"
  })));
};

MicrosoftIcon.defaultProps = {
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  xmlns: "http://www.w3.org/2000/svg"
};
var styles = {
  socialButton: {
    height: 40,
    display: 'flex',
    fontSize: 14,
    color: 'common.white',
    alignItems: 'center',
    '& > span': {
      mr: 1.5
    },
    '&:hover': {
      color: 'common.white'
    }
  },
  google_btn: {
    width: 210,
    p: 0.125,
    pr: 1.5,
    boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'additional.googleBlue',
    '& > span': {
      height: 38,
      width: 38,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'common.white'
    }
  },
  outlook_btn: {
    width: 210,
    p: 1.5,
    backgroundColor: 'additional.msDark',
    '& > span': {
      height: 19
    }
  }
};
var BUTTON_VARIANTS = {
  outlook: {
    icon: /*#__PURE__*/_react["default"].createElement(MicrosoftIcon, null),
    signInText: 'Sign in with Microsoft',
    text: 'Integrate with Microsoft'
  },
  google: {
    icon: /*#__PURE__*/_react["default"].createElement(GoogleIcon, null),
    signInText: 'Sign in with Google',
    text: 'Integrate with Google'
  }
};

var EmailIntegrationButton = function EmailIntegrationButton(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'google' : _ref$variant,
      _ref$signIn = _ref.signIn,
      signIn = _ref$signIn === void 0 ? false : _ref$signIn,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? [] : _ref$sx,
      linkProps = (0, _objectWithoutProperties2["default"])(_ref, ["variant", "signIn", "onClick", "sx"]);
  var _BUTTON_VARIANTS$vari = BUTTON_VARIANTS[variant],
      icon = _BUTTON_VARIANTS$vari.icon,
      text = _BUTTON_VARIANTS$vari.text,
      signInText = _BUTTON_VARIANTS$vari.signInText;
  return /*#__PURE__*/_react["default"].createElement(_material.Link, (0, _extends2["default"])({
    href: "#auth",
    onClick: onClick,
    sx: [styles.socialButton, styles["".concat(variant, "_btn")]].concat((0, _toConsumableArray2["default"])(Array.isArray(sx) ? sx : [sx]))
  }, linkProps), /*#__PURE__*/_react["default"].createElement("span", null, icon), " ", signIn ? signInText : text);
};

var _default = EmailIntegrationButton;
exports["default"] = _default;